import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["sendEmailLink", "emailSentMessage"]

  connect() {
    this.sendEmailLinkTarget.addEventListener("ajax:success", this.handleSuccess.bind(this));
    this.sendEmailLinkTarget.addEventListener("ajax:error", this.handleError.bind(this));
    this.sendEmailLinkTarget.addEventListener("ajax:beforeSend", this.beforeSend.bind(this))
  }


  handleSuccess(event) {
    this.sendEmailLinkTarget.classList.add("d-none");
    this.emailSentMessageTarget.classList.remove("d-none");
  }

  beforeSend(event) {
    this.sendEmailLinkTarget.setAttribute("disabled", "disabled");
  }

  handleError(event) {
    alert(window.i18n.t("view.admin.accounting_email_controller.something_went_wrong"));
  }

}
